import gql from 'graphql-tag';

export const GdprSettingsQuery = gql`
  query GdprSettingsQuery($thirdPartyOrganizationId: String!) {
    GdprSettingsV1Resource {
      get(id: $thirdPartyOrganizationId) {
        id
        gdprMode
        allowAccountLinking
        recoveryPasswordAtCreation
        recoveryAccountAfterFirstEnrollment
        recoveryAccountOnHomePage
      }
    }
  }
`;
